import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import { useOrderStore } from "../stores/orderStore";
import { useSessionStore } from "../stores/sessionStore";

function ProgressItem({
  isActive,
  label,
  onClick,
  disabled,
}: {
  isActive: boolean;
  label: string;
  onClick?: () => void;
  disabled?: boolean;
}) {
  return (
    <button
      className={clsx("flex items-center gap-2 cursor-pointer", {
        "opacity-50": !isActive && disabled,
        "cursor-default": disabled,
      })}
      onClick={onClick}
      disabled={disabled}
    >
      <div className="size-6 sm:size-5 border-[1.5px] border-black rounded-full flex flex-center shrink-0">
        {isActive && <div className="bg-black size-4 sm:size-3 rounded-full" />}
      </div>
      <span className="text-sm sm:text-base font-medium sm:font-normal">{label}</span>
    </button>
  );
}

export default function Progress() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const selectedDate = useOrderStore((s) => s.selectedDate);
  const { session } = useSessionStore();

  const isCalendar = location.pathname === "/";
  const isBoten = location.pathname.startsWith("/items") || location.pathname.startsWith("/addons");
  const isGegevens = location.pathname === "/gegevens";

  const canGoBoten = !!selectedDate;
  const canGoGegevens = !!session && (session.status === "pending" || session.status === "checked_out");

  return (
    <div>
      <div className="flex items-center gap-3 sm:gap-3">
        <ProgressItem
          isActive={isCalendar}
          label={t("progress.date")}
          onClick={() => navigate("/")}
        />
        <div className="h-px w-3 sm:w-5 bg-black opacity-40 sm:opacity-100"></div>
        <ProgressItem
          isActive={isBoten}
          label={t("progress.boats")}
          onClick={() => navigate("/items/1")}
          disabled={!canGoBoten}
        />
        <div className="h-px w-3 sm:w-5 bg-black opacity-40 sm:opacity-100"></div>
        <ProgressItem
          isActive={isGegevens}
          label={t("progress.details")}
          onClick={() => navigate("/gegevens")}
          disabled={!canGoGegevens}
        />
      </div>
    </div>
  );
}
